export default "__VITE_ASSET__DOabVoGk__"